export default __webpack_public_path__ + "static/media/shipetiari2.bd3e7c9d.jpg";